var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickImageSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#6FDF97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3517 25.771C17.0551 25.771 16.7553 25.6576 16.5285 25.4293L12.8413 21.7436C12.3862 21.2886 12.3862 20.5524 12.8413 20.0973C13.2964 19.6422 14.0326 19.6422 14.4877 20.0973L17.3517 22.9582L23.8999 16.4116C24.3549 15.9565 25.0911 15.9565 25.5462 16.4116C26.0013 16.8667 26.0013 17.6029 25.5462 18.058L18.1749 25.4293C17.9481 25.6576 17.6499 25.771 17.3517 25.771Z",
    fill: "#021239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickImageSuccess);
export default __webpack_public_path__ + "static/media/tickImageSuccess.e54450950f0f23aee76f48f7affa1399.svg";
export { ForwardRef as ReactComponent };